import { render, staticRenderFns } from "./JdongConf.vue?vue&type=template&id=1c0be9d2"
import script from "./JdongConf.vue?vue&type=script&lang=js"
export * from "./JdongConf.vue?vue&type=script&lang=js"
import style0 from "./JdongConf.vue?vue&type=style&index=0&id=1c0be9d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports